import Vue from 'vue'
import _ from 'lodash'
import axios from 'axios'

const vue = new Vue({
  el: `#site-search`,
  data() {
    return {
      isOpen: false,
      searchValue: '',
      activeTab: 'all',
      searchResult: [],
      emptyResult: false
    }
  },
  methods: {
    toggle() {
      if (this.isOpen)
        this.close()
      else
        this.open()
    },
    toggleTab(category){
      if(category)
        this.activeTab = category.id;
      else
        this.activeTab = 'all';
    },
    open() {
      this.isOpen = true
      document.body.classList.add(`page--stop-scroll`)

      // After animation end
      setTimeout(() => {
        this.$refs.searchField.focus()
      }, 500)
    },
    close() {
      this.isOpen = false
      document.body.classList.remove(`page--stop-scroll`)
    },
    search: _.debounce(function(value) {
      axios.get('/ajax/search.php', {
        params: {
          q: JSON.stringify(value.toLowerCase())
        }
      })
      .then((response) => {
        this.searchResult = response.data
        if (this.searchResult.length <= 0) {
            this.emptyResult = true;
        } else {
            this.emptyResult = false;
        }
      })
    }, 500)
  },
  watch: {
    searchValue(value) {
      this.search(value)
    }
  },
  mounted() {
    document.addEventListener(`keyup`, (evt) => {
      var path
      path = evt.path || (evt.composedPath && evt.composedPath())

      if (path.includes(this.$el) && evt.code === `Escape`)
        this.close()
    })
  }
})
